// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__8NpXI","tab":"ProcedureTabs_tab__2JAQq"};